//once your settings-web page is fully developed and tested, add it here to ensure the nav bar and router redirect to the new page
//you will also have to change your Route to a Redirect in /scripts/app/routes/SettingsRoutes.js
export const CUTOVER_SETTINGS_ROUTES = Object.freeze([
    { path: '/account' },
    { path: '/company' },
    { path: '/security' },
    { path: '/consent' },
    { path: '/help' },
    { path: '/widget' },
    { path: '/team' },
    { path: '/billing' },
    { path: '/email' },
])



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Routing/constants.js